export const loadScriptTag = (options) => {
  const script = window.document.createElement('script');
  if (options.innerContent) script.innerHTML = options.innerContent;
  if (options.src) script.src = options.src;
  if (options.async) script.async = true;
  window.document.body.appendChild(script);
};



// WEBPACK FOOTER //
// ./src/app/admin/services/utils/scriptLoader.js